import Firebase from 'firebase'
var config = {
   apiKey: "AIzaSyAuyUMAw4kxXO3KieIl9QDSc4I9pk-W5no",
   authDomain: "digitalt-sikkerhedstjek.firebaseapp.com",
   databaseURL: "https://digitalt-sikkerhedstjek.firebaseio.com",
   projectId: "digitalt-sikkerhedstjek",
   storageBucket: "",
   messagingSenderId: "913077774601"
 };
 const firebaseApp = Firebase.initializeApp(config);
 export const db = firebaseApp.database();



// WEBPACK FOOTER //
// ./src/database/firebase.js